import React from 'react';
import { RefreshCw, X, AlertCircle } from 'lucide-react';

interface VersionUpdateBannerProps {
  onDismiss?: () => void;
}

export const VersionUpdateBanner: React.FC<VersionUpdateBannerProps> = ({ onDismiss }) => {
  const handleRefresh = () => {
    // Force reload to get the new version
    window.location.reload();
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 dark:bg-amber-600 text-white shadow-lg">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <AlertCircle className="w-5 h-5 flex-shrink-0" />
          <p className="text-sm md:text-base font-medium">
            Új verzió érhető el! A zavartalan működés érdekében kérjük, fejezd be az aktuális
            folyamatot, majd frissítsd az oldalt.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleRefresh}
            className="bg-white text-amber-600 dark:bg-amber-50 dark:text-amber-700 px-4 py-2 rounded-lg font-bold text-sm hover:bg-amber-50 dark:hover:bg-amber-100 transition shadow-md flex items-center gap-2"
          >
            <RefreshCw size={16} />
            Frissítés most
          </button>
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="p-2 hover:bg-amber-600 dark:hover:bg-amber-700 rounded-lg transition"
              aria-label="Bezárás"
            >
              <X size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
